<template>
  <a-row :gutter="20">
    <a-col :span="isDesktop?12:24">
      <a-card title="Social Media" class="style3">
        <p>Download the Social Media Kit</p>
        <button type="button" class="btn btn-info btn-lg">
          <a
            href="https://s3.amazonaws.com/truelifeassets/Social+Media+Kit.zip"
            style="color:#FFF;"
          >Social Media Kit</a>
        </button>
        <p></p>
      </a-card>
    </a-col>
    <a-col :span="isDesktop?12:24">
      <a-card title="Media Resources" class="style3">
        <p>Download the Media Kit</p>
        <button type="button" class="btn btn-info btn-lg">
          <a
            href="https://s3.amazonaws.com/truelifeassets/Media+Package.zip"
            style="color:#FFF;"
          >Media Package</a>
        </button>
        <p></p>
      </a-card>
    </a-col>
  </a-row>
</template>
<script>
import { mapState } from 'vuex';
export default {
  computed: {
    ...mapState(['settings']),
    isDesktop() {
      return !this.settings.isMobileView && !this.settings.isTabletView;
    },
  },
};
</script>
